export default function manufacturerUrl(slug) {
  return `/brand/${slug}`
}
